import React from 'react';

const LandingIntroVideo = () => (
  <section className="care-landing-section care-landing-container care-landing-video-option">
    <div className="care-landing-section-heading">
      <h2>Meet Lifelog</h2>
    </div>
    <video
      controls
      playsInline
      preload="none"
      poster="/media/intro-to-lifelog-poster.jpg"
      aria-label="Introduction to Lifelog"
    >
      <source src="/media/intro-to-lifelog.mp4" type="video/mp4" />
      Your browser does not support video playback. <a href="/media/intro-to-lifelog.mp4">Watch the introduction</a>.
    </video>
  </section>
);

export default LandingIntroVideo;
